import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { Constant } from 'src/Constant';
import { GlobalServiceService } from 'src/app/Services/GlobalService/global-service.service';
import { WINDOW } from 'ngx-window-token';

@Component({
  selector: 'app-razor-pay-thankyou',
  templateUrl: './razor-pay-thankyou.component.html',
  styleUrls: ['./razor-pay-thankyou.component.css']
})
export class RazorPayThankyouComponent implements OnInit {
  consumerID: any;
  currentDate: any;
  refranceID: any;
  amount: any;

  resData: any = [];
  mandateData: any;
  isSuccess: boolean = false;
  source: any;
  constructor(private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private service: GlobalServiceService,
  
  ) { }

  ngOnInit(): void {
    this.resData = []
    if (localStorage.getItem('s2sResponse')) {
      this.mandateData = JSON.parse(localStorage.getItem('s2sResponse') || '{}');
      this.resData.push(this.mandateData)
      this.callAPI();
    }

    this.route.queryParams.subscribe(params => {
      const source = params['source'];
      this.source = source;
      console.log(source); // do something with the error
    });
  }
  
  ngOnDestroy() {
    localStorage.clear();
  }

  callAPI() {

    if (this.source = 'RP_UPI') {
      this.saveResUPI()
    }
    if (this.source = 'RP_NB') {
      this.saveResNB()
    }

  }

  copyToClipboard(text: string) {
  
    navigator.clipboard.writeText(text).then(() => {
      console.log('Text copied to clipboard');
    }, (err) => {
      console.error('Could not copy text: ', err);
    });
  }


  saveResNB() {
    let url = Constant.saveMandateSign;
    if (this.mandateData) {
      let reqObj = {
        "razorpay_PaymentId": this.mandateData.razorpay_payment_id,
        "razorpay_orderId": this.mandateData.razorpay_order_id,
        "razorpay_signiture": this.mandateData.razorpay_signature,
      }
      this.spinner.show();
      this.service.PostService(url, reqObj).subscribe((response: any) => {
        if (response) {
          this.spinner.hide();
          this.consumerID = '1234'
          this.currentDate = moment(new Date()).format('DD-MM-YYYY')
          this.refranceID = response.token_id
          this.amount = (response.token.max_amount / 100)
          this.isSuccess = true;
        }
        else {
          alert(response.p_message);
        }
      })
    }
  }


  saveResUPI() {
    let url = Constant.saveMandateSignUPI;
    if (this.mandateData) {
      let reqObj = {
        "razorpay_PaymentId": this.mandateData.razorpay_payment_id,
        "razorpay_orderId": this.mandateData.razorpay_order_id,
        "razorpay_signiture": this.mandateData.razorpay_signature,
      }
      this.spinner.show();
      this.service.PostService(url, reqObj).subscribe((response: any) => {
        if (response) {
          this.spinner.hide();
          this.consumerID = '1234'
          this.currentDate = moment(new Date()).format('DD-MM-YYYY')
          this.refranceID = response.token_id
          this.amount = (response.token.max_amount / 100)
          this.isSuccess = true;
        }
        else {
          alert(response.p_message);
        }
      })
    }

  }




}
